import ApiClient from '@/libs/http-client'

const DocumentTypesService = {
    endpoints(route, param) {
        const url = {
            documentTypes: '/api/document-types',
            documentType: `/api/document-types/${param}`,
        }
        return url[route]
    },
    get(url, param = {}, config = {}) {
        return ApiClient.get(this.endpoints(url, param), config)
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config)
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config)
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config)
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config)
    }
}

export default DocumentTypesService
